import { useState, useEffect } from "react"
import { useParams, useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import Moment from "react-moment";
import PanelHeader from "components/PanelHeader/PanelHeader";
import BlockedPhoneNumberService from "core/api/BlockedPhoneNumberService";
import { CrudDropdownEditDelete } from "views/Shared/CrudDropdownEditDelete";


const View = () => {
    const { id } = useParams();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const history = useHistory();


    useEffect(() => {
        async function fetchData() {
            const blockedPhoneNumber = await BlockedPhoneNumberService.get(id);

            setData(blockedPhoneNumber);

            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;
    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            Blocked Number
                        </h1>
                        <h2 className="title">
                            {data?.phoneNumber}
                        </h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <CardTitle tag="h4">Blocked Number Information</CardTitle>
                                <Col xs="auto">
                                    <CrudDropdownEditDelete
                                        id={id}
                                        onDelete={() => {
                                            BlockedPhoneNumberService.delete(id);
                                            history.goBack();
                                        }}
                                        deletePermissions={["all:phone_numbers", "delete:phone_numbers", "admin"]}
                                        editPermissions={["all:phone_numbers", "write:phone_numbers", "admin"]}
                                    />
                                </Col>
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Phone Number:</strong> {data?.phoneNumber}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Blocked From:</strong> {data?.blockedFrom && <Moment format="MM/DD/YYYY">{data.blockedFrom}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Blocked Until:</strong> {data?.blockedUntil && <Moment format="MM/DD/YYYY">{data.blockedUntil}</Moment>}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Reason:</strong> {data?.reason}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Blocked By:</strong> {data?.blockedBy}
                                    </ListGroupItem>
                                </ListGroup>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View
